import { ActionTypes, ClearRouter, SaveItems } from './types';

import { RouteItem } from '@/types/route';

const saveRouterItems = (payload: RouteItem[] | []): SaveItems => ({
  type: ActionTypes.SAVE_ITEMS,
  payload,
});
const clearRouter = (): ClearRouter => ({
  type: ActionTypes.CLEAR_ROUTER,
});

export { saveRouterItems, clearRouter };
